import { logApiEvent, markErrorLogged, isErrorLogged } from '@/utils/sentry-logger'

class FetchTransport {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  async fetch(url, options) {
    const absoluteUrl = new URL(this.baseUrl + url)
    if (options?.searchParams) {
      Object.keys(options.searchParams).forEach((key) => {
        if (options.searchParams[key] !== undefined) {
          absoluteUrl.searchParams.append(key, options.searchParams[key])
        }
      })
    }
    const requestStartTime = Date.now()
    try {
      const response = await fetch(absoluteUrl, options)
      return response
    } catch (error) {
      // Network error (offline, DNS failure, CORS, etc.)
      if (!isErrorLogged(error)) {
        logApiEvent(
          url,
          options?.method || 'GET',
          {
            errorMessage: error.message || 'Network error',
            errorName: error.name,
            errorStack: error.stack?.substring?.(0, 500),
            statusCode: 'NETWORK_ERROR',
            responseTime: Date.now() - requestStartTime,
            timestamp: new Date().toISOString(),
          },
          'failure'
        )
        // Track error to avoid duplicate Sentry events in higher layers
        markErrorLogged(error)
      }
      throw error
    }
  }
}

export const fetchTransport = new FetchTransport(process.env.VUE_APP_API_URL)
